/** Minimal focus trap for modal/dialog surfaces — keyboard baseline only. */
const FOCUSABLE = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
export function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE)).filter((el) => !el.hasAttribute('disabled') && el.getAttribute('aria-disabled') !== 'true');
}
export function trapFocus(container, event) {
    if (event.key !== 'Tab')
        return;
    const focusable = getFocusableElements(container);
    if (focusable.length === 0) {
        event.preventDefault();
        container.focus();
        return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey) {
        if (active === first || !container.contains(active)) {
            event.preventDefault();
            last.focus();
        }
        return;
    }
    if (active === last) {
        event.preventDefault();
        first.focus();
    }
}
//# sourceMappingURL=focus-trap.js.map